var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"level"},[_vm._v(_vm._s(_vm.experienceInformationResult.apiResult.level))]),_vm._v(" "),(_vm.levelUpAnimation)?_c('LevelUpComponent',{attrs:{"new-level":''+_vm.experienceInformationResult.apiResult.level,"finishedHandler":_vm.deactivateLevelUpAnimation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }